// libNN.VideoSources.js
// 2023/10 init

import Device from './_Device.js'

class VideoSourceItem {
  constructor(video) {
    this.$video = video
    this.setting = {}
    this.init()
    this.clearDataset()
  }
  init() {
    this.setting.pc = JSON.parse(this.$video.dataset.src)
    this.setting.sp = JSON.parse(this.$video.dataset.src_sp)
  }
  resize(device) {
    this.clearSource()
    this.createSource(this.setting[device].webm, 'video/webm')
    this.createSource(this.setting[device].mp4, 'video/mp4')
  }
  clearDataset() {
    this.$video.dataset.src = 'null'
    this.$video.dataset.src_sp = 'null'
  }
  clearSource() {
    this.$video.querySelectorAll('source').forEach(source => {
      source.remove()
    })
  }
  createSource(src, type) {
    const source = document.createElement('source')
    source.setAttribute('type', type)
    source.setAttribute('src', src)
    this.$video.appendChild(source)
  }
}

class VideoSources {
  constructor(selector, breakpoint) {
    this.$videos = document.querySelectorAll(selector);
    this.isSP = window.matchMedia(`(max-width: ${breakpoint}px)`)
    this.breakpoint = breakpoint
    this.videos = []
    if(this.$videos) {
      this.init()
      this.bind()
    }
  }
  init() {
    this.$videos.forEach(v => {
      this.videos.push(new VideoSourceItem(v))
    })
  }
  bind() {
    new Device({
      breakpoint: this.breakpoint,
      pc: _ => {
        this.resize('pc')
      },
      sp: _ => {
        this.resize('sp')
      }
    })
  }
  resize(device) {
    this.videos.forEach(v => {
      v.resize(device)
    })
  }
}
export default VideoSources;
